/* ──────────────────────────────────────────────
 *  Choix qu'une prestation laisse au client EN DEHORS de sa formule : supplément, nombre de personnes,
 *  quantité. Un seul verdict pour la carte prestation (« Choisir » sélectionne tout de suite ou déplie
 *  la carte) et pour l'entrée du tunnel (étape prestations sautée ou non, spec Parcours § 3 cas 3 et
 *  11) : une prestation que la carte déplierait n'est jamais jugée « complète » à l'entrée, sinon la
 *  pré-réservation partirait sans `party_size` ni supplément (prix et capacité d'une personne).
 * ────────────────────────────────────────────── */

import { isPartySizeSelectable } from '@cfixe-monorepo/shared';
import type { BookingPrestation } from '../types';

/**
 * Vrai dès qu'un supplément est proposé, que le nombre de personnes est ouvert (sélecteur activé par le pro
 * ET plafond > 1, cf. `isPartySizeSelectable`) ou qu'une quantité peut être choisie. La formule se juge à
 * part : la carte compte les formules affichées, l'entrée du tunnel les formules proposables.
 */
export const hasChoicesBeyondPrice = (prestation: BookingPrestation): boolean =>
  (prestation.supplements ?? []).length > 0 || isPartySizeSelectable(prestation) || (prestation.max_quantity ?? 1) > 1;
